import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import SliderWrapper from "jd-library/SliderWrapper";
import historyHandler from "jd-library/historyHandler";
import Dropdown from 'jd-library/Dropdown';
import styles from './delivery_slider.scss';
import Loader from "jd-library/Loader";

const DeliverySlider = props => {
    let { heading, headerVariant, onHidden, onSubmit, singleOutletAcc, productData={}, deliveryIdPair='', outletData='' } = props;
    let { outletWiseDeliveryList=[] } = productData;
    let [delivIdMapping, setDelivIdMapping] = useState(null);
    let [outletDetails, setOutletDetails] = useState([]);
    const [inputElements, setInputElements] = useState([]);
    let [showLoader, setLoader] = useState(false);

    useEffect(() => {
        if(!outletDetails.length){
            setDelivIdMapping(deliveryIdPair);
            setOutletDetails(outletData);
        }else{
            updateInputElements();
        }
    }, [outletWiseDeliveryList, outletDetails]);

    const setDelivProfile = (value, index) => {
        let temp = [...outletDetails];
        let selectedOutlet = temp[index];
        selectedOutlet.selectedProfile = value;
        setOutletDetails(temp);
        // if(singleOutletAcc)
        //     prepareServiceData()
    }

    const updateInputElements = () => {
        const dropdownElements = outletDetails.map((item, index) => {
            const options = item.deliveryOptions.reduce((acc, option) => {
                acc.push({key: option, label: option, item})
                return acc;
            }, []);

            return {
                key: JSON.stringify(item),
                className:'dropdown-div',
                optionList: options,
                dropDownStyles: options.length > 1 ? {} : {minHeight: "60px"},
                onChange: (e, value) => { 
                    setDelivProfile(e.key, index);
                },
                label: singleOutletAcc ? 'Delivery Profile' : (item.name || item.area),
                placeholder: singleOutletAcc ? 'Delivery Profile' : (item.name || item.area),
                value : item.selectedProfile
            }
        });
        setInputElements(dropdownElements);
    }

    const prepareServiceData = () => {
        let outletWiseDeliveryList = [];
        let upFrontData = [];
        outletDetails.map((outlet, index) => {
            outletWiseDeliveryList.push({
                outletId: outlet.outletId,
                deliveryProfileId: delivIdMapping[outlet.outletId][outlet.selectedProfile]
            })
            upFrontData.push({
                key: outlet.name,
                value: outlet.selectedProfile
            })
        })
        let responseData = [{
            key: 'outletWiseDeliveryList',
            value: outletWiseDeliveryList   
        }];
        onSubmit(responseData, upFrontData);
        historyHandler.closeCurrent();
    }

    return (
        <SliderWrapper
            header={{
                heading: (heading || 'Delivery Profiles'),
                variant: (headerVariant || 'secondary'),
                rightIcons: []
            }}
            onHidden={() => onHidden(false)}
            footer={{
                btnProps: [
                    {
                        children: 'Save',
                        clickHandler: () => {
                            prepareServiceData();
                        },
                        size: "lg"
                    }
                ]
            }}
        >
            <div className={`${styles['delivery-slider']} ${styles["multi-outlet"]}`}>
                {inputElements.map((ele, index) => (
                    <Dropdown key={`delProfile_${index}`} {...ele} />
                ))}
            </div>
            {showLoader && <Loader/>}
        </SliderWrapper> 
    );
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        permissions: state.permissions
    };
};
export default connect(mapStateToProps, {})(DeliverySlider);